/*
 * @Date: 2023-10-08 14:28:36
 * @Description: RCEP主题库，包含 数据 + 监测 + 报告
 */
import Layout from "@/layout";
import { rcep } from "../utils/reflectionrcep";
export default [
  {
    path: "/rcep",
    redirect: "/rcep/home",
  },
  {
    path: "/rcep/data",
    component: Layout,
    redirect: "/rcep/data/goods",
    name: "data",
    meta: {
      title: "数据",
      icon: "iconfont iconshuju1",
      theme: "rcep",
    },
    children: [
      {
        path: "goods",
        name: "goodsTrade",
        redirect: "/rcep/data/goods/world",
        component: () => import("@/views/data/goods/common-theme"),
        meta: { title: "货物贸易" },
        children: [
          {
            path: "world",
            redirect: "/rcep/data/goods/world/monthly",
            newpath: "/data/goods/world/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "world",
            meta: { title: "世界", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["世界月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["世界年度"],
              },
            ],
          },
          // {
          //   path: "asean",
          //   redirect: "/rcep/data/goods/asean/monthly",
          //   component: () => import("@/views/data/goods/common-theme"),
          //   name: "asean",
          //   newpath: "/data/goods/asean/detail",
          //   meta: { title: "东盟", icon: "iconshuju2 2-1" },
          //   children: [
          //     {
          //       path: "monthly",
          //       component: () =>
          //         import("@/views/data/goods/common-theme/CommonTheme"),
          //       name: "monthly",
          //       meta: rcep["东盟季度"],
          //     },
          //     {
          //       path: "annual",
          //       component: () =>
          //         import("@/views/data/goods/common-theme/CommonTheme"),
          //       name: "annual",
          //       meta: rcep["东盟年度"],
          //     },
          //   ],
          // },
          {
            path: "china",
            redirect: "/rcep/data/goods/china/monthly",
            newpath: "/data/goods/asia/china/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "china",
            meta: {
              title: "中国",
              icon: "iconshuju2 2-1",
              showOnlyOneChild: true,
            },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["中国月度"],
              },
            ],
          },
          {
            path: "japan",
            redirect: "/rcep/data/goods/japan/monthly",
            newpath: "/data/goods/asia/japan/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "japan",
            meta: { title: "日本", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["日本月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["日本年度"],
              },
            ],
          },
          {
            path: "korea",
            redirect: "/rcep/data/goods/korea/monthly",
            newpath: "/data/goods/asia/korea/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "korea",
            meta: { title: "韩国", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["韩国月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["韩国年度"],
              },
            ],
          },
          {
            path: "indonesia",
            redirect: "/rcep/data/goods/indonesia/monthly",
            newpath: "/data/goods/asia/indonesia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "indonesia",
            meta: { title: "印度尼西亚", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["印尼月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["印尼年度"],
              },
            ],
          },
          {
            path: "malaysia",
            redirect: "/rcep/data/goods/malaysia/monthly",
            newpath: "/data/goods/asia/malaysia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "malaysia",
            meta: { title: "马来西亚", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["马来西亚月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["马来西亚年度"],
              },
            ],
          },
          {
            path: "philippines",
            redirect: "/rcep/data/goods/philippines/monthly",
            newpath: "/data/goods/asia/philippines/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "philippines",
            meta: { title: "菲律宾", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly2023",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly2023",
                meta: rcep["菲律宾月度2023"],
              },
              {
                path: "monthly2024",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly2024",
                meta: rcep["菲律宾月度2024"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["菲律宾年度2023"],
              },
            ],
          },
          {
            path: "thailand",
            redirect: "/rcep/data/goods/thailand/monthly",
            newpath: "/data/goods/asia/thailand/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "thailand",
            meta: { title: "泰国", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["泰国月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["泰国年度"],
              },
            ],
          },

          {
            path: "singapore",
            redirect: "/rcep/data/goods/singapore/monthly",
            newpath: "/data/goods/singapore/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "singapore",
            meta: { title: "新加坡", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["新加坡季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["新加坡年度"],
              },
            ],
          },
          {
            path: "brunei",
            redirect: "/rcep/data/goods/brunei/monthly",
            newpath: "/data/goods/brunei/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "brunei",
            meta: { title: "文莱", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["文莱季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["文莱年度"],
              },
            ],
          },
          {
            path: "cambodia",
            redirect: "/rcep/data/goods/cambodia/monthly",
            newpath: "/data/goods/cambodia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "cambodia",
            meta: { title: "柬埔寨", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["柬埔寨季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["柬埔寨年度"],
              },
            ],
          },
          {
            path: "laos",
            redirect: "/rcep/data/goods/laos/monthly",
            newpath: "/data/goods/laos/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "laos",
            meta: { title: "老挝", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["老挝季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["老挝年度"],
              },
            ],
          },
          {
            path: "myanmar",
            redirect: "/rcep/data/goods/myanmar/monthly",
            newpath: "/data/goods/myanmar/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "myanmar",
            meta: { title: "缅甸", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["缅甸季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["缅甸年度"],
              },
            ],
          },
          {
            path: "vietnam",
            redirect: "/rcep/data/goods/vietnam/monthly",
            newpath: "/data/goods/vietnam/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "vietnam",
            meta: { title: "越南", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["越南季度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["越南年度"],
              },
            ],
          },
          {
            path: "australia",
            redirect: "/rcep/data/goods/australia/monthly",
            newpath: "/data/goods/australia/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "australia",
            meta: { title: "澳大利亚", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["澳大利亚月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["澳大利亚年度"],
              },
            ],
          },
          {
            path: "xxl",
            redirect: "/rcep/data/goods/xxl/monthly",
            newpath: "/data/goods/dyz/xxl/detail",
            component: () => import("@/views/data/goods/common-theme"),
            name: "xxl",
            meta: { title: "新西兰", icon: "iconshuju2 2-1" },
            children: [
              {
                path: "monthly",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "monthly",
                meta: rcep["新西兰月度"],
              },
              {
                path: "annual",
                component: () =>
                  import("@/views/data/goods/common-theme/CommonTheme"),
                name: "annual",
                meta: rcep["新西兰年度"],
              },
            ],
          },
        ],
      },
    ],
  },
];
